import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

export type BubbleItem = { id: string; photo: string };

export function bubblePhotoUrl(item: BubbleItem): string {
  return `/api/files/team_members/${item.id}/${item.photo}`;
}

export function useHomeBubbles() {
  return useQuery({
    queryKey: ['home-bubbles'],
    queryFn: (): Promise<{ items: BubbleItem[] }> =>
      pb.send('/api/home/bubbles', { method: 'GET' }),
    staleTime: 5 * 60_000,
    retry: false,
  });
}
